import React, { Component } from "react";
import { Switch, BrowserRouter as Router, Redirect } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/";
import AppRoute from "./routes/route";

// layouts
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getLayout = this.getLayout.bind(this);
  }
  componentDidMount() {
    const getUserData = localStorage.getItem("infoSalonsUser");
    // console.log("uses  ", JSON.parse(getUserData));
    if (getUserData) {
      this.props.loggedinUser(JSON.parse(getUserData));
    }
  }
  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  render() {
    const Layout = this.getLayout();
    const { isLoggedIn } = this.props.user;
    // console.log("isLoggedIn", isLoggedIn);
    // if (!isLoggedIn) return <Redirect to="/login" />;
    return (
      <React.Fragment>
        <Router>
          <Switch>
            {!isLoggedIn ? (
              <>
                {publicRoutes.map((route, idx) => (
                  <AppRoute
                    path={route.path}
                    layout={NonAuthLayout}
                    component={route.component}
                    key={idx}
                    exact={route.exact}
                    isAuthProtected={false}
                    isLoggedIn={isLoggedIn}
                  />
                ))}
              </>
            ) : (
              <>
                {authProtectedRoutes.map((route, idx) => (
                  <AppRoute
                    path={route.path}
                    layout={Layout}
                    component={route.component}
                    key={idx}
                    exact={route.exact}
                    isAuthProtected={true}
                    isLoggedIn={isLoggedIn}
                  />
                ))}
              </>
            )}
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
    user: state.User,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loggedinUser: (data) => dispatch({ type: "USER_LOGIN", payload: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
